export enum Cookie {
    LoginSession = 'login_session',
    Vid = 'VID',
    AdminUserId = 'AUID',
}
